import { render, staticRenderFns } from "./LogisticsShipment.vue?vue&type=template&id=4ddb3857&scoped=true&"
import script from "./LogisticsShipment.vue?vue&type=script&lang=js&"
export * from "./LogisticsShipment.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsShipment.vue?vue&type=style&index=0&id=4ddb3857&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb3857",
  null
  
)

export default component.exports